import React from "react";
import "./ExpertTeam.css";
import painter from "../assets/painter.png";
import carpenter from "../assets/carpenter.png";
import plumber from "../assets/plumber.png";

const ExpertTeam = () => {
  return (
    <div className="team-container">
      <div className="team-inner-box">
        <h2 className="team-title">Our Expert Team</h2>
        <div className="team-grid">
          <div className="team-card">
            <h3>Painter</h3>
            <img src={painter} alt="Painter" className="team-img" />
            <p>
              Partnered with professional painters to deliver flawless, lasting
              finishes for every space.
            </p>
            <button className="team-btn">Book Our Expert Painters</button>
          </div>
          <div className="team-card">
            <h3>Carpenters</h3>
            <img src={carpenter} alt="Carpenter" className="team-img" />
            <p>
              Collaborating with expert carpenters to ensure precision and
              craftsmanship in every detail.
            </p>
            <button className="team-btn">Book Our Expert Carpenters</button>
          </div>
          <div className="team-card">
            <h3>Plumbers</h3>
            <img src={plumber} alt="Plumber" className="team-img" />
            <p>
              Working with certified plumbers to provide reliable, efficient
              plumbing solutions.
            </p>
            <button className="team-btn">Book Our Expert Plumbers</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertTeam;
